import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiUrls } from '../../../../config/api-urls/api-urls';
import { MainService } from '../../../../provider/main.service';

@Component({
  standalone: false,
  selector: 'app-add-subadmin',
  templateUrl: './add-subadmin.component.html'
})
export class AddSubadminComponent implements OnInit {
  addSubAdminForm: FormGroup | any;
  file: any;
  imageType: any;
  imageUrl: any;
  countryArr: any = [];
  constructor(private service: MainService, private router: Router) { }

  ngOnInit() {
    this.addSubAdminFormValidation();
    this.getCountryCodeData()
  }

  // Add Subadmin Form Validation

  addSubAdminFormValidation() {
    this.addSubAdminForm = new FormGroup({
      'file': new FormControl(''),
      'firstName': new FormControl('', Validators.compose([Validators.required, Validators.maxLength(62), Validators.pattern(/^[^\s][a-zA-Z ]*$/)])),
      'lastName': new FormControl(''),
      'phoneCode': new FormControl('+1'),
      "email": new FormControl('', ([Validators.required, Validators.pattern(/^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/i), Validators.maxLength(50)])),
      "phoneNumber": new FormControl('', ([Validators.required, Validators.pattern(/^[1-9][0-9]{9,13}$/)])),
      "password": new FormControl('', Validators.compose([Validators.required, Validators.minLength(8), Validators.pattern(/^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,16}$/)])),
      "confirmPassword": new FormControl('', Validators.compose([Validators.required, Validators.minLength(8)])),
      'dashboard': new FormControl(false),
      'patientManagement': new FormControl(false),
      'therapistManagement': new FormControl(false),
      'programManagement': new FormControl(false),
      'subadminManagement': new FormControl(false),
      'transactionManagement': new FormControl(false),
      'assessment': new FormControl(false),
      'staticContentManagement': new FormControl(false),
      'notificationManagement': new FormControl(false),
      'libraryManagement': new FormControl(false),
      'reviewManagement': new FormControl(false),
      'chatManagement': new FormControl(false),
      'journalManagement': new FormControl(false),
      'faqManagement': new FormControl(false),
      'queryManagement': new FormControl(false),
      'programTypeManagement': new FormControl(false)
    })
  }

  ValidateFileUpload(event: any) {
    this.file = event.target.files;
    if (this.file[0]) {
      this.imageType = this.file[0].type;
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.imageUrl = e.target.result;
        this.uploadImage()
      };
      reader.readAsDataURL(this.file[0]);
    }
  }

  uploadImage() {
    const data: FormData = new FormData();
    data.append('image', this.file[0])
    this.service.postApi(ApiUrls.uploadImage, data, 3).subscribe((res) => {
      if (res.responseCode == 200) {
        this.imageUrl = res.result.image
      }
    })
  }

  // Block special character from name
  inputkeyPress(e: any) {
    var k
    if (e.charCode == 32 && !e.target.value) {
      e.preventDefault()
    }
    else {
      document.all ? k = e.keyCode : k = e.which;
      return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32);
    }
  }
  //Allow only numbers
  inputKeyPress(e: any) {
    var k
    if (e.charCode == 32 && !e.target.value) {
      e.preventDefault()
    }
    else {
      document.all ? k = e.keyCode : k = e.which;
      return ((k > 47 && k < 58) || k == 8);
    }
  }

  //For password keypres
  passwordKeyPress(e: any) {
    if (e.charCode == 32 && !e.target.value) {
      e.preventDefault()
    }
  }

  getCountryCodeData() {
    this.service.getCountryCode().subscribe((res) => {
      this.countryArr = res
    })
  }

  addSubAdminApi() {
    const data = {
      'firstName': this.addSubAdminForm.value.firstName,
      'lastName': this.addSubAdminForm.value.lastName,
      'email': this.addSubAdminForm.value.email,
      'countryCode': this.addSubAdminForm.value.phoneCode,
      'mobileNumber': this.addSubAdminForm.value.phoneNumber,
      'profilePic': this.imageUrl,
      'password': this.addSubAdminForm.value.password,
      'dashboard': this.addSubAdminForm.value.dashboard,
      'patientManagement': this.addSubAdminForm.value.patientManagement,
      'therapistManagement': this.addSubAdminForm.value.therapistManagement,
      'programManagement': this.addSubAdminForm.value.programManagement,
      'subadminManagement': this.addSubAdminForm.value.subadminManagement,
      'transactionManagement': this.addSubAdminForm.value.transactionManagement,
      'assesmentManagement': this.addSubAdminForm.value.assesmentManagement,
      'contentManagement': this.addSubAdminForm.value.staticContentManagement,
      'notificationManagement': this.addSubAdminForm.value.notificationManagement,
      'libraryManagement': this.addSubAdminForm.value.libraryManagement,
      'reviewManagement': this.addSubAdminForm.value.reviewManagement,
      'chatManagement': this.addSubAdminForm.value.chatManagement,
      'journalManagement': this.addSubAdminForm.value.journalManagement,
      'faqManagement': this.addSubAdminForm.value.faqManagement,
      'queryManagement': this.addSubAdminForm.value.queryManagement,
      'programTypeManagement': this.addSubAdminForm.value.programTypeManagement
    };
    this.service.showSpinner();
    this.service.postApi(ApiUrls.addSubadmin, data, 1).subscribe((res) => {
      this.service.hideSpinner();
      if (res.responseCode == 200) {
        this.router.navigate(['subadmin-mgt']);
        this.service.successToast(res.responseMessage)
      }
      else {
        this.service.errorToast(res.responseMessage)
      }
    })
  }

  onImageError(event: any) {
    event.target.src = 'https://res.cloudinary.com/smsit/image/upload/v1597335652/fmcvdi2g6ogd5vwzvzfa.jpg';
  }

}
